import React from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Chip,
  Stack,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ErrorRoundedIcon from '@mui/icons-material/ErrorRounded';
import { arrayOf, func, shape } from 'prop-types';
import * as R from 'ramda';
import CarrierSelection from '../components/CarrierSelection';

const Carriers = ({ info, setInfo }) => {
  const { carriers = [] } = info;
  const carrierLength = R.length(carriers);

  return (
    <Accordion defaultExpanded>
      <AccordionSummary
        aria-controls="customer-customerAuth-content"
        expandIcon={<ExpandMoreIcon sx={{ color: 'primary.main' }} />}
      >
        <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
          <Typography variant="body2">Carriers</Typography>
          {!!carrierLength && <Chip label={carrierLength} type="accordion" variant="badge" />}
          {R.and(R.equals(R.prop('isCarrierRestricted', info), 'true'), R.isEmpty(carriers)) && (
            <ErrorRoundedIcon sx={{ color: 'error.main' }} />
          )}
        </Stack>
      </AccordionSummary>
      <AccordionDetails>
        <CarrierSelection hideTitle info={info} setInfo={setInfo} />
      </AccordionDetails>
    </Accordion>
  );
};

Carriers.propTypes = {
  info: shape({
    carriers: arrayOf(shape({})),
  }),
  setInfo: func.isRequired,
};

Carriers.defaultProps = {
  info: {
    carriers: [],
    isCarrierRestricted: false,
  },
};

export default Carriers;
